import { render, staticRenderFns } from "./LunaStatsAdmin.vue?vue&type=template&id=79988c24&scoped=true"
import script from "./LunaStatsAdmin.vue?vue&type=script&lang=js"
export * from "./LunaStatsAdmin.vue?vue&type=script&lang=js"
import style0 from "./LunaStatsAdmin.vue?vue&type=style&index=0&id=79988c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79988c24",
  null
  
)

export default component.exports